<section>
    <div class="title-images-container">
        <div class="text-wrapper" data-aos="fade-right" data-aos-duration="1000">
            <h1 class="section-title" data-aos="fade-down" data-aos-delay="200">
                Nuestros <span class="highlight">Proyectos</span>
                <!-- <span class="word highlight">Proyectos</span> -->
            </h1>
            <p class="section-subtitle animated-text">
                {{ currentSubtitle }}
            </p>
        </div>

        <!-- desktop -->
        <div class="images-wrapper desktop-layout" *ngIf="currentLayout === 'desktop'"
            [ngClass]="'expand-' + expandedIndex" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="300">
            <ng-container *ngFor="let img of visibleImages; let i = index; trackBy: trackByFn">
                <div class="image-container" [class.expanded]="img.isExpanded" [attr.data-aos]="'zoom-in'"
                    [attr.data-aos-delay]="100 + (i * 150)">
                    <img [src]="img.url" [alt]="img.caption" />
                </div>
            </ng-container>
        </div>

        <!-- tablet -->
        <div class="tablet-layout" *ngIf="currentLayout === 'tablet'" data-aos="fade-left" data-aos-duration="1000">
            <div class="tablet-grid">
                <ng-container *ngFor="let img of tabletImages; let i = index">
                    <div class="tablet-image-container" [class.large-image]="img.isLarge"
                        [class.small-image]="!img.isLarge" [attr.data-aos]="'zoom-in'"
                        [attr.data-aos-delay]="100 + (i * 150)">
                        <img [src]="img.url" [alt]="img.caption" class="fade-in" />
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- mobile -->
        <!-- <div class="mobile-layout" *ngIf="currentLayout === 'mobile'" data-aos="fade-up" data-aos-duration="1000">
            <div class="mobile-image-container" [attr.data-index]="mobileCurrentIndex">
                <img [src]="images[mobileCurrentIndex].url" [alt]="images[mobileCurrentIndex].caption"
                    class="fade-in" />
            </div>
        </div> -->
        <div class="mobile-layout-2" *ngIf="currentLayout === 'mobile'" data-aos="fade-up" data-aos-duration="1000">
            <div class="card" [style.background-image]="getBackgroundImage(0)"></div>
            <div class="card" [style.background-image]="getBackgroundImage(5)"></div>
            <div class="card" [style.background-image]="getBackgroundImage(2)"></div>
        </div>
    </div>
</section>